import { useEffect } from "react";

const useAuthorizeNetScript = () => {
  useEffect(() => {
    const scriptId = "authorize-net-script";
    const scriptExists = document.getElementById(scriptId);

    if (!scriptExists) {
      const script = document.createElement("script");
      script.src =
        process.env.ACCEPT_JS_URL ||
        "https://js.authorize.net/v1/Accept.js";
      script.type = "text/javascript";
      script.charset = "utf-8";
      script.id = scriptId;
      script.async = true;

      document.body.appendChild(script);
    }
  }, []);
};

export default useAuthorizeNetScript;
